import React from "react";
import { useHistory } from "react-router-dom";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "../langs/useTranslation";
import DataTable from "@/components/DataTable";
import { Rule } from "./DeviceNamingDatatable";
import { OSTypeChip } from "@/components/FormFields/OSType";
import { getMerchantConfigInfo } from "@/apis/apiCollection";
import ChipStatus from "@/components/ChipStatus";

export const GroupDeviceNamingConfigDatatable = React.forwardRef(
  ({ className, style, groupId, children, onLoaded }, ref) => {
    const { t } = useTranslation();
    const history = useHistory();

    const toDetail = e => {
      e.preventDefault();
      const url = new URL(e.target.href);
      history.push(url.pathname);
    };

    const columns = [
      {
        width: 70,
        searchable: false,
        className: "center",
        title: t({ defaultMessage: "序号" }),
        render: (data, type, row, meta) => {
          return meta.row + 1;
        }
      },
      {
        data: "osType",
        title: t({ defaultMessage: "设备系统类型" }),
        createdCell: (td, data) => {
          ReactRender(<OSTypeChip type={data} />, td);
        }
      },
      {
        data: "configName",
        title: t({ defaultMessage: "关联配置文件" }),
        createdCell: (td, data, row) => {
          ReactRender(
            <a
              href={`/profile-config/template-${row.osType}/${row.configId}`}
              onClick={toDetail}
            >
              {data}
            </a>,
            td
          );
        }
      },
      {
        data: "namingRuleName",
        title: t({ defaultMessage: "命名规则名称" }),
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              <span>{data}</span>
              {!!data && (
                <ChipStatus
                  style={{ marginLeft: 5 }}
                  type="default"
                  label={row.namingRuleStatus === 0 ? "enabled" : "disabled"}
                />
              )}
            </>,
            td
          );
        }
      },
      {
        data: "namingRuleRules",
        title: t({ defaultMessage: "命名规则" }),
        createdCell: (td, data, row) => {
          ReactRender(
            <Rule
              rules={JSON.parse(data || "[]")}
              delimiter={row.namingRuleDelimiter}
            />,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      return getMerchantConfigInfo({
        ...data,
        groupId
      }).then(res => {
        callback({
          data: res.configs,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        ordering={false}
        paging={false}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        showFooter={false}
        autoLoad
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
